import { render } from "./vcurriculumclassifyadd.vue?vue&type=template&id=444aa89a&scoped=true"
import script from "./vcurriculumclassifyadd.vue?vue&type=script&lang=js"
export * from "./vcurriculumclassifyadd.vue?vue&type=script&lang=js"

import "./vcurriculumclassifyadd.vue?vue&type=style&index=0&id=444aa89a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444aa89a"]])

export default __exports__